import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-primary-400 whitespace-nowrap">
              韩漫网
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              韩国漫画网 — 国内领先的韩漫免费在线阅读平台。提供恋爱、奇幻、动作、悬疑等全类型韩国漫画，下拉式阅读模式让您享受极致流畅的漫画浏览体验。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-400 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-400 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  全部分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-foreground-400 mb-4">
              订阅更新
            </h4>
            <p className="text-sm text-foreground-300 mb-3">
              订阅我们的更新通知，第一时间获取最新韩漫上线信息。
            </p>
            <form
              id="newsletter-form"
             
              action="http://dakunkj.cn/"
              method="POST"
              className="flex flex-col sm:flex-row gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                required
                className="flex-1 bg-foreground-800 border border-foreground-700 rounded-md px-3 py-2 text-sm text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors duration-200"
              />
              <button
                type="submit"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
              <div className="visually-hidden-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩国漫画网. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}